export const CONTAINER_MAX_WIDTH = 1000;
export const MAX_FEEDBACK_CONTAINER_WIDTH = 500;
export const FEEDBACK_NAVIGATION_WIDTH = 42;
export const FEEDBACK_MEDIA_QUERY = { query: `(min-width: 1620px)` };
